import styled from "styled-components"

import truckDark from "../../images/svg/topYogunluk/truck-dark.svg"
import truckLight from "../../images/svg/topYogunluk/truck-light.svg"

import yukDark from "../../images/svg/topYogunluk/list-dark.svg"
import yukLight from "../../images/svg/topYogunluk/list-light.svg"

import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {BsCalendar2Check} from "react-icons/bs"

const Container = styled.div`
    width: 100%;
    border-radius: 15px;
    color: ${({ theme }) => theme.mainTextColor};

    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 10px 20px;
    border-radius: 10px;


    .item-date-container{
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-lg);

    .icon-container{
        display: flex;
        justify-content: center;
        align-items: center;

        .icon{
            font-size: 1.2rem;
        }
    }
}

    .garaj-name{
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-lg);
      width: 20%;
    }


    .yogunluk-container{
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 70%;

      .yogunluk-item{
        display: flex;
        align-items: center;
        width: 100%;

        img{
          width: 25px;
          margin-right: 10px;
        }

        .text{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          width: 140px;
        }

        .number{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }

      }

    }


`

const Line = styled.div`
  width: 180px;
  height: 12px;
  margin-right: 20px;

  .line{
    height: 100%;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(to right, green, yellow, red);


    .inner{
      transition: 1s;
      height: 100%;
      width: ${({sizeInner}) => sizeInner};
      background-color: transparent;
    }

    .upper{
      transition: 1s;
      width: ${({sizeUpper}) => sizeUpper};
      background-color: grey;
      background-color:  ${({ theme }) => theme.scrollThumbColor};
      height: 100%;
    }
  }
`

const GarajDetayListItemAnimated = ({item}) => {
    
    const {theme} = useSelector(state => state.layout)

    const dispatch = useDispatch()

    const [isOk, setIsOk] = useState(false)
    
    const [yukCounter, setYukCounter] = useState(0)

    const [aracCounter, setAracCounter] = useState(0)

    const yukTimer = 1000 / item.loadDensity
    const aracTimer = 1000 /item.vehicleDensity

    useEffect(() => {
        const timeout = setTimeout(() => {
          setIsOk(true)
        } ,200)
  
        return ()=> {
          clearTimeout(timeout)
        }
      },[])

      useEffect(()=> {
        const interval1 = setInterval(() => {
            if(item.loadDensity > yukCounter){
                setYukCounter((yukCounter) => yukCounter + 1);
            }
          }, yukTimer);
      
          return () => {
            clearInterval(interval1);
          };
      },[yukCounter ])

      useEffect(()=> {
        const interval2 = setInterval(() => {
            if(item.vehicleDensity > aracCounter){
                setAracCounter((aracCounter) => aracCounter + 1);
            }
          }, aracTimer);

          return () => {
            clearInterval(interval2);
          };
      },[aracCounter])


  return (
    <Container>
                <div className="item-date-container">
            <div className="icon-container">
                <BsCalendar2Check className="icon"/>
            </div>
            <div className="date">{item.entryTime}</div>
            <div className="time">{item.time}</div>
        </div>
        <div className="yogunluk-container">
            <div className="yogunluk-item">
            <img src={theme === "dark" ? yukLight : yukDark} alt={item.garaj+"yuk"} />
            <div className="text">Yük Yoğunluğu</div>
                <div className="line-container">
                    <Line sizeInner={isOk ? `${item.loadDensity}%`: 0} sizeUpper={isOk ? `${100 - item.loadDensity}%`: "100%"}>
                        <div className="line">
                            <div className="inner"></div>
                            <div className="upper"></div>
                        </div>
                    </Line>
                </div>
                {
                    isOk &&
                    <div className="number" style={{color: yukCounter <= 33 ? "#0EAC00" : yukCounter <= 66 ? "#EBB00E" :"#FF0000" }}>%{yukCounter}</div>
                }
            </div>
            <div className="yogunluk-item">
            <img src={theme === "dark" ? truckLight : truckDark } alt={item.garaj+"yuk"} />
            <div className="text">Araç Yoğunluğu</div>

            <div className="line-container">
                    <Line izeInner={isOk ? `${item.vehicleDensity}%`: 0} sizeUpper={isOk ? `${100 - item.vehicleDensity}%`: "100%"} >
                        <div className="line">
                            <div className="inner"></div>
                            <div className="upper"></div>
                        </div>
                    </Line>
                </div>
        
            {
                isOk &&
                <div className="number" style={{color: aracCounter <= 33 ? "#0EAC00" : aracCounter <= 66 ? "#EBB00E" :"#FF0000" }}>%{aracCounter}</div>
            }
            </div>
        </div>
    </Container>
  )
}

export default GarajDetayListItemAnimated
